import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  headerTitleProductEnv: {
    id: 'upgradePopupModal.headerTitleProductEnv',
    defaultMessage: 'Take advantage of multiple product environments',
  },
  noteProductEnv: {
    id: 'upgradePopupModal.noteProductEnv',
    defaultMessage: "You've reached the max of 1 product environment on your free plan.",
  },
  headerTitleAddUser: {
    id: 'upgradePopupModal.headerTitleAddUser',
    defaultMessage: 'Enjoy powerful collaboration with your team',
  },
  noteAddUser: {
    id: 'upgradePopupModal.noteAddUser',
    defaultMessage: "You've reached the max of 3 users on your free plan.",
  },
  title: {
    id: 'upgradePopupModal.title',
    defaultMessage: 'Upgrade your plan to enjoy:',
  },
  additionalUsers: {
    id: 'upgradePopupModal.additionalUsers',
    defaultMessage: 'Additional users',
  },
  moreProductEnvironments: {
    id: 'upgradePopupModal.moreProductEnvironments',
    defaultMessage: 'More product environments',
  },
  higherUsageLimits: {
    id: 'upgradePopupModal.higherUsageLimits',
    defaultMessage: 'Higher usage limits',
  },
  backup: {
    id: 'upgradePopupModal.backup',
    defaultMessage: 'Backup to your own S3 or Google Cloud bucket',
  },
  access: {
    id: 'upgradePopupModal.access',
    defaultMessage: 'Access to free and paid add-ons',
  },
  errorReports: {
    id: 'upgradePopupModal.errorReports',
    defaultMessage: 'Error reports',
  },
  expeditedSupport: {
    id: 'upgradePopupModal.expeditedSupport',
    defaultMessage: 'Expedited support',
  },
  upgradeOptionsButton: {
    id: 'upgradePopupModal.upgradeOptionsButton',
    defaultMessage: 'See Upgrade Options',
  },
  accountManagementButton: {
    id: 'upgradePopupModal.accountManagementButton',
    defaultMessage: 'Go to Account Management',
  },
  userManagementButton: {
    id: 'upgradePopupModal.userManagementButton',
    defaultMessage: 'Go to User Management',
  },
});
